{
  "title": "Éléments modèles",
  "subtitle": "Fonctionnalité de référence pour les conventions frontend",
  "filters": {
    "status": "Statut",
    "allStatuses": "Tous les statuts"
  },
  "columns": {
    "name": "Nom",
    "price": "Prix",
    "status": "Statut",
    "createdAt": "Créé le"
  },
  "status": {
    "active": "Actif",
    "archived": "Archivé"
  },
  "fields": {
    "name": "Nom",
    "price": "Prix (USD)"
  },
  "list": {
    "empty": "Aucun élément",
    "error": "Impossible de charger les éléments. Veuillez réessayer.",
    "refreshing": "Actualisation"
  },
  "create": {
    "submit": "Ajouter",
    "success": "Élément ajouté",
    "error": "Impossible d'ajouter l'élément. Veuillez réessayer."
  },
  "errors": {
    "TEMPLATE_ITEM_NAME_TAKEN": "Ce nom est déjà utilisé",
    "REQUIRED": "Ce champ est obligatoire",
    "INVALID_PRICE": "Saisissez un prix supérieur ou égal à 0"
  }
}
